import React from 'react';

/**
 * Renders the small Markdown subset the copilot writes: paragraphs, bullet
 * and numbered lists, headings, **bold** and `code`. Builds React elements
 * only, so reply text is never injected as HTML.
 */
const FormattedText = ({ text }) => (
    <>
        {text.split(/\n{2,}/).map((block, i) => (
            <React.Fragment key={i}>{renderBlock(block)}</React.Fragment>
        ))}
    </>
);

function renderBlock(block) {
    const parts = [];
    let current = null;

    for (const line of block.split('\n')) {
        const bullet = line.match(/^\s*(?:[-*•])\s+(.*)$/);
        const numbered = line.match(/^\s*\d+[.)]\s+(.*)$/);
        const heading = line.match(/^\s*#{1,6}\s+(.*)$/);

        if (bullet || numbered) {
            const type = bullet ? 'ul' : 'ol';
            if (current?.type !== type) parts.push((current = { type, lines: [] }));
            current.lines.push((bullet || numbered)[1]);
        } else if (heading) {
            parts.push((current = { type: 'heading', lines: [heading[1]] }));
            current = null;
        } else if (line.trim()) {
            if (current?.type !== 'p') parts.push((current = { type: 'p', lines: [] }));
            current.lines.push(line);
        }
    }

    return parts.map((part, i) => {
        if (part.type === 'ul' || part.type === 'ol') {
            const List = part.type;
            return <List key={i}>{part.lines.map((line, j) => <li key={j}>{inline(line)}</li>)}</List>;
        }
        if (part.type === 'heading') {
            return <p key={i}><strong>{inline(part.lines[0])}</strong></p>;
        }
        return (
            <p key={i}>
                {part.lines.map((line, j) => (
                    <React.Fragment key={j}>{j > 0 && <br />}{inline(line)}</React.Fragment>
                ))}
            </p>
        );
    });
}

function inline(text) {
    return text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((part, i) => {
        if (part.length > 4 && part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        if (part.length > 2 && part.startsWith('`') && part.endsWith('`')) {
            return <code key={i}>{part.slice(1, -1)}</code>;
        }
        return part;
    });
}

export default FormattedText;
